import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Modal from 'components/common/Modal'
import Media from 'components/common/Media'
import getComponent from 'helpers/component-helper'

const ForgotPasswordModal = ({
  data: { modalBoxContent = []},
  forgotPasswordTitle,
  handleHide,
  ...props
}) =>
  <CustomModal title={ forgotPasswordTitle } closeHandler={ handleHide }>
    {
      modalBoxContent
        .map((Component, index) => React.cloneElement(getComponent(Component), { ...props, key: index, handleHide }))
    }
  </CustomModal>

export default ForgotPasswordModal

ForgotPasswordModal.propTypes = {
  data: PropTypes.shape({
    modalBoxContent: PropTypes.arrayOf(PropTypes.shape())
  }),
  forgotPasswordTitle: PropTypes.string,
  handleHide: PropTypes.func
}

const CustomModal = styled(Modal)`
  ${Media.desktop`
    top: 265px;
  `}
`
